import { Snackbar } from '@material-ui/core'
import MuiAlert from '@material-ui/lab/Alert'

import successIcon from '@/public/images/icons/success-toast.svg'
import errorIcon from '@/public/images/icons/error-toast.svg'
import warningIcon from '@/public/images/icons/icon-warning.svg'

function Alert(props) {
  return <MuiAlert style={{ zIndex: 10000 }} className="toast_alert" elevation={6} variant="filled" {...props} />
}

export type ComponentProps = {
  open: boolean
  handleClose: any
  message?: string | any
  severity?: string
  style?: React.CSSProperties
}

export const Toast: React.FC<ComponentProps> = ({ open, handleClose, severity, message }) => {
  const respSeverity = () => {
    if (severity === 'success') {
      return successIcon.src
    } else if (severity === 'error') {
      return errorIcon.src
    } else if (severity === 'warning') {
      return warningIcon.src
    }
  }

  return (
    <>
      <Snackbar
        open={open}
        autoHideDuration={6000}
        onClose={handleClose}
        style={{ zIndex: 10000 }}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
      >
        <Alert
          icon={
            <img
              /* src={severity === 'success' ? successIcon.src : errorIcon.src} */
              src={respSeverity()}
              style={{ width: '30px', height: '30px' }}
            />
          }
          onClose={handleClose}
          severity={severity}
          style={{ zIndex: 3000 }}
        >
          {typeof message === 'string' ? (
            <>{message}</>
          ) : (
            <>
              {message ? (
                <>
                  Errors
                  <ul>
                    {Object.keys(message).map((value, key) => (
                      <li key={key}>{message[value]}</li>
                    ))}
                  </ul>
                </>
              ) : (
                <></>
              )}
            </>
          )}
        </Alert>
      </Snackbar>
      <style jsx>{`
        :global(.MuiAlert-filledSuccess) {
          color: #065f46 !important;
          background-color: #ecfdf5 !important;
        }
        :global(.toast_alert) {
          align-items: center;
        }
        :global(.MuiAlert-filledError) {
          color: #b91c1c !important;
          background-color: #fef2f2 !important;
        }
        :global(.MuiAlert-filledWarning) {
          color: #b45309 !important;
          background-color: #fffbeb !important;
        }
      `}</style>
    </>
  )
}

export default Toast
